import { FC, useContext } from 'react';

import { PlansSection, PropertyDataSection, TableFeatures } from './components';

import { StepTwoFormContext } from '../../contexts/StepTwoForm';


import './index.css';
import { PLAN_TYPE } from '../../../../../shared';

interface TabsPropertyDataHomeProps {
  duplicateId?: number;
  id: number;
}

export const TabsPropertyDataHome: FC<TabsPropertyDataHomeProps> = ({
  duplicateId,
  id,
}) => {
  const { planTypeSelected } = useContext(StepTwoFormContext);

  return (
    <div className='mt-1'>
      {planTypeSelected === PLAN_TYPE.OPEN && (
        <PlansSection duplicateId={duplicateId} id={id} />
      )}

      <PropertyDataSection duplicateId={duplicateId} id={id} />

      {planTypeSelected === PLAN_TYPE.OPEN && (
        <TableFeatures duplicateId={duplicateId} id={id} />
      )}
    </div>
  );
};
